export default "__VITE_ASSET__DEIZY0c1__"